import { useEffect, useState } from 'react'

import { InputNumber, Modal } from 'antd'
import { useSelector } from 'react-redux'

import { InstitutionOptions, OPTIONS_WITH_DAY_VALUES } from '../../utils/constants'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import FormItem from '../shared/Forms/FormItem'
import OptionEmailsForm from './OptionEmailsForm'

const MIN_VALUE = 1

const INTEGER_OPTIONS = [InstitutionOptions.STUDENT_INTERNSHIP_REQUEST_LIMIT]

const toNumber = value => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const parsed = Number(value)

  return isNaN(parsed) ? null : parsed
}

const OptionValueModal = ({ option, title, onCancel, onOk }) => {
  const t = useSelector(selectTranslate)

  const [value, setValue] = useState(null)

  const optionType = option?.optionType?.type
  const isEmailsOption = optionType === InstitutionOptions.SEND_MATCHING_HOSPITAL_EMAIL
  const isDayOption = OPTIONS_WITH_DAY_VALUES.includes(optionType)
  const isIntegerOption = INTEGER_OPTIONS.includes(optionType)

  const numericValue = toNumber(value)
  const isValidValue = numericValue !== null && numericValue >= MIN_VALUE && (!isIntegerOption || Number.isInteger(numericValue))

  useEffect(() => {
    if (option) {
      setValue(toNumber(option.optionValue))
    }
  }, [option])

  const handleOk = () => {
    if (isValidValue) {
      onOk(numericValue)
    }
  }

  const handleKeyDown = event => {
    if (isIntegerOption && event.key.length === 1 && !/\d/.test(event.key) && !event.ctrlKey && !event.metaKey) {
      event.preventDefault()

      return
    }

    if (event.key === 'Enter') {
      handleOk()
    }
  }

  const renderBody = () => {
    if (!option) {
      return null
    }

    if (isEmailsOption) {
      return <OptionEmailsForm option={option} />
    }

    return (
      <FormItem label={`institution_option.type.${optionType}`}>
        <div className='vertical-center gap-8'>
          <InputNumber
            autoFocus
            min={MIN_VALUE}
            precision={isIntegerOption ? 0 : undefined}
            value={value}
            onChange={setValue}
            onKeyDown={handleKeyDown}
            style={{ width: '90px' }}
          />
          {isDayOption && <span>{t('days')}</span>}
        </div>
      </FormItem>
    )
  }

  return (
    <Modal
      visible={!!option}
      title={title}
      onOk={handleOk}
      onCancel={onCancel}
      afterClose={() => setValue(null)}
      centered
      width={isEmailsOption ? '100vw' : 420}
      style={isEmailsOption ? { maxHeight: '80vh' } : undefined}
      footer={isEmailsOption ? null : undefined}
      okText={t('common.save')}
      cancelText={t('common.cancel')}
      okButtonProps={{ disabled: !isValidValue }}
    >
      {renderBody()}
    </Modal>
  )
}

export default OptionValueModal
